import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    del,
    formDataPatch,
    formDataPost,
    get,
    patch,
    post,
} from "helpers/api_helper";

import {
    GET_ALL_PLANS,
    GET_CURRENT_SUBSCRIPTION,
    START_FREE_TRIAL
} from "helpers/url_helper";

export const getAllPlans = createAsyncThunk(
    GET_ALL_PLANS,
    async (payload) => {
        const response = await get(GET_ALL_PLANS);
        return response;
    }
);
export const startFreeTrial = createAsyncThunk(
    START_FREE_TRIAL,
    async (payload) => {
        const response = await post(START_FREE_TRIAL,payload);
        return response;
    }
);
export const myCurrentSubscription = createAsyncThunk(
    GET_CURRENT_SUBSCRIPTION,
    async (payload) => {
        const response = await get(GET_CURRENT_SUBSCRIPTION);
        return response;
    }
);